module.exports = __webpack_public_path__ + "static/14-081eb49f41a88174214a16d738bbe3c8.png";